import resources from '../../data/resources.json';
import blogArchive from '../../data/blogArchive.json';
import { headingText } from '../../utils/headingText';
import { useEffect, useState } from "react";
import { sanityClient } from "../../api/sanityClient";
import { Link } from "react-router-dom";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    sanityClient
      .fetch(`*[_type == "blogPost" && !(_id in path("drafts.**")) && coalesce(archived, false) == false && !(slug.current in $archivedSlugs) && defined(slug.current) && defined(publishedAt) && publishedAt <= now()] | order(publishedAt desc){
        _id,
        title,
        slug,
        excerpt,
        coverImage,
        "imageUrl": coverImage.asset->url,
        _createdAt,
        _updatedAt
      }`, { archivedSlugs: blogArchive.map(post => post.slug) })
      .then((data) => {

        setPosts((data || []).filter(post => !post.archived && !blogArchive.some(item => item.slug === post.slug?.current)));
        setStatus("ready");
      })
      .catch(() => setStatus("error"));
  }, []);

  const allPosts = [...resources.map(guide => ({_id: guide.slug, title: guide.title, slug: {current: guide.slug}, excerpt: guide.description})), ...posts];
  return (
    <section className="md:px-8 md:py-12 px-4 py-8">
      {status === "error" && <p role="status" className="mb-6">Additional articles are temporarily unavailable. The planning guides below are available.</p>}
      <div className="blog-grid grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {allPosts.map((post) => (
          <Link to={`/insights/${post.slug?.current}`} key={post._id}>
            <div className="border rounded-md p-4 hover:shadow-md h-full flex flex-col">
              {post.imageUrl && (
                <img src={post.imageUrl} alt={post.title} className="mb-4 h-48 object-cover w-full" />
              )}
              <h2 className="text-xl font-semibold">{headingText(post.title)}</h2>
              {post.excerpt && (
                <p className="text-gray-600 mt-2 text-sm">{post.excerpt}</p>
              )}
              <p className="mt-auto text-brand-pink text-sm font-medium hover:underline pt-8">
                Read more →
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
